export const limits = {
  childrenRegisterBrowser: 500,
  childRegisterDocumentsPreview: 500,
  obligationReportChildrenList: 500,
  schoolDistrictsChildrenAssignmentList: 500,
  auditLog: 500,
  schoolStat: 500,
  synchronizationsLog: 10,
  personalDataAccessList: 500,
  usersPersonalDataAccessList: 500,
  printedStudentsList: 500,
};
